module.exports = __webpack_public_path__ + "img/sdg_en_(3).9c742df4.png";